import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const organisationWelcomeWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.welcome",
  name: "Organisation overview",
  description: "A half-width welcome card with two live headline measures.",
  apps: [
    "appointments",
    "asset",
    "attendance",
    "configuration",
    "contracts",
    "crm",
    "document",
    "expenses",
    "field-service",
    "finance",
    "help-desk",
    "home",
    "hr",
    "integrations",
    "inventory",
    "invoicing",
    "maintanance",
    "manufacturing",
    "payroll",
    "point-of-sale",
    "procurement",
    "project",
    "recruitment",
    "rental",
    "sales",
    "schedule-planning",
    "subscriptions",
    "time-off",
    "timesheets",
  ],
  template: "welcome",
  query: {
    kind: "metrics",
    metrics: [
      {
        label: "Revenue this month",
        query: {
          version: 1,
          source: "sales.analysis",
          ...period(30),
          select: [
            {
              type: "aggregate",
              function: "sum",
              field: "revenue",
              as: "revenue",
            },
          ],
        },
        output: "number",
        format: "currency",
        color: "success",
        maximum: 100000,
      },
      {
        label: "Effective tax rate",
        query: {
          version: 1,
          source: "sales.analysis",
          ...period(30),
          select: [
            {
              type: "formula",
              as: "tax_rate",
              data_type: "percentage",
              expression: {
                type: "binary",
                operator: "multiply",
                left: {
                  type: "binary",
                  operator: "safe_divide",
                  left: {
                    type: "aggregate",
                    function: "sum",
                    field: "tax_amount",
                  },
                  right: {
                    type: "aggregate",
                    function: "sum",
                    field: "untaxed_amount",
                  },
                },
                right: {
                  type: "literal",
                  value: 100,
                },
              },
            },
          ],
        },
        output: "percentage",
        format: "percentage",
        color: "primary",
        maximum: 100,
      },
    ],
  },
  inputs: {
    title: "Welcome back",
    subtext: "Your live business snapshot is ready.",
    illustrationAlt: "Business performance illustration",
  },
  dummyData: {
    title: "Welcome back",
    metrics: [
      "$84,250",
      "18.4%",
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
